<template>
  <!-- nav-header-wrap 该样式定义在crm-navigator-header这个组件中 -->
  <header id="header" class="main-header nav-header-wrap">
    <div class="header-right">
      <div class="left-content" style="flex:1">
        <QaSearch v-if="$route.path === '/im'"></QaSearch>
      </div>

      <!-- <div class="float-left small-nav menuheader" id="headerMenu" /> -->
      <navigation-header :userInfo="userInfo" ref="navigatorHeader" v-bind="headerAttrs">
        <template #left>
          <slot name="left"></slot>
        </template>
      </navigation-header>
      <div class="v-flex-middle">
        <CountryOption :localesResult="this.localesResult" />
        <Language :localesResult="this.localesResult" />
        <ZoneOption :localesResult="this.localesResult" />
        <!-- <ToggleStatus
          v-if="hasStatus && !showTRStatus && !isTRCallIn && !(hasTRCallInExtension && !isIm)"
          :statusList="statusList"
          :currentStatus="currentStatus"
          @change="changeStatus"
          :imStatus="imStatus"
          :isReconnect="isReconnect"
          :isRegionCallIn="isRegionCallIn"
        ></ToggleStatus> -->
      </div>
    </div>
  </header>
</template>

<script>
import request from '@/util/request'
import { mapGetters, mapActions } from 'vuex'
import ToggleStatus from '@/components/ToggleStatus'
import { crmRequest, setLocal, getLocal } from '@meta-vue/util'
import Language from '@/components/Language'
import ZoneOption from '@/components/ZoneOption'
import CountryOption from '@/components/CountryOption'
import CallUserConfig from '@/components/CallUserConfig'
import CallStatus from '@call-sdk/call-status'
import { createTRInbound as CreateTRInbound, CallSdk } from '@call-sdk/core'
import QuestionnaireInquiry from '@/components/QuestionnaireInquiry.vue'
import '@call-sdk/call-status/lib/style.css'
import debounce from 'lodash/debounce'
import NavigationHeader from '@meta-vue/navigation-header'
import WorkbenchUtilDialog from '@/components/workbench-util-dialog'
import QaSearch from '@/components/qaSearch'
import { getStatusList } from './const'
import { changeStatus } from './service'
// import * as Avaya from '@/extend/avaya'

import { refreshWindowAndClearMemory, scriptLoad } from '@/util/tools'

const Config = process.env
// import { isWarningMemoryStatus } from '@/plugins/perfMoniter'
import { LOCALE_STORE_KEY } from '../../constant'

export default {
  name: 'CrmHeader',
  components: { ToggleStatus, NavigationHeader, Language, QaSearch, ZoneOption, CountryOption },
  props: {
    hasStatus: {
      type: Boolean,
      required: true
    },
    imStatus: {
      type: Number,
      required: true
    },
    isIm: {
      type: Boolean,
      required: true
    },
    navigationHeaderAttrs: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dialogVisible: false,
      // 当前状态
      currentStatus: 2,
      asyncComponent: null,
      sharedWorker: null,
      stateList: [],
      hasTRCallInExtension: false,
      isReconnect: false,
      localesResult: []
    }
  },
  watch: {
    // isIm: {
    //   // 检查im路由 展示客服状态，和电话工作台区分
    //   handler(val, oldval) {
    //     if (val) {
    //       window.removeEventListener('avaya', this.avayaHandle)
    //       window.removeEventListener('avaya-control', this.avayaControlHandle)
    //       window.removeEventListener('avaya-connected-state-change', this.connectedStateChange)
    //     } else {
    //       window.addEventListener('avaya', this.avayaHandle) // 对状态的监听
    //       window.addEventListener('avaya-control', this.avayaControlHandle) // 对话机的操作
    //       window.addEventListener('avaya-connected-state-change', this.connectedStateChange) // 对状态的监听
    //     }
    //   },
    //   immediate: true
    // },
    imStatus: {
      handler(val, oldval) {
        if (this.isIm) {
          this.currentStatus = val
        }
      },
      immediate: true
    },
    // '$route.path' () {
    //   this.checkPem()
    // }
    statusList: {
      immediate: true,
      deep: true,
      handler() {
        // 在线客服的默认状态是离线
        if (this.isIm) {
          this.currentStatus = 3
        } else {
          this.currentStatus = 2
        }
      }
    }
  },
  computed: {
    ...mapGetters('Authentication', ['UserInfo']),
    ...mapGetters('caller', ['HasAgent', 'HasTrNum']),
    userInfo() {
      return this.UserInfo.user || {}
    },
    // 客服状态 分情况显示不同的状态list
    statusList() {
      return getStatusList(this.isIm)
    },
    isTRCallIn() {
      return this.$route.path.includes('/tr_callin/')
    },
    isRegionCallIn() {
      return this.$route.path.includes('/region-callin/')
    },
    showTRStatus() {
      return (
        this.hasTRCallInExtension &&
        (this.isTRCallIn ||
          this.$route.path.includes('personal/tempsave') ||
          this.$route.path.includes('personal/casehistory') ||
          this.$route.path.includes('region-callin-loss-report') ||
          this.$route.path.includes('suggestion/detail') ||
          this.$route.path.includes('dms/seatmonitor'))
      )
    },
    headerAttrs() {
      return {
        visibleMenu: [],
        // hideMainContent: false,
        showNavMenu: false,
        showSearch: false,
        ...this.navigationHeaderAttrs
      }
    }
  },
  async mounted() {
    this.localesResult = await crmRequest({
      url: '/qmove-metadata-admin/locale/queryLocales',
      method: 'get',
      needLoading: false,
      mock: false
    })
    if (getLocal(LOCALE_STORE_KEY) == null) {
      const country = this.localesResult[0]?.country?.key
      const language = this.localesResult[0]?.languages[0]?.key
      const timeZone = this.localesResult[0]?.timeZones[0]?.key
      setLocal(
        LOCALE_STORE_KEY,
        { country: country, lang: language, timeZone: timeZone },
        { expire: 1000 * 60 * 60 * 24 * 365 }
      )
      window.location.reload()
    } else {
      const locales = getLocal(LOCALE_STORE_KEY)
      if (locales.lang && locales.country == undefined && locales.timeZone == undefined) {
        const country = this.localesResult[0]?.country?.key
        const timeZone = this.localesResult[0]?.timeZones[0]?.key
        setLocal(
          LOCALE_STORE_KEY,
          { country: country, lang: locales.lang, timeZone: timeZone },
          { expire: 1000 * 60 * 60 * 24 * 365 }
        )
        window.location.reload()
      } else if (locales.lang == undefined && locales.country && locales.timeZone) {
        const localeInfo = this.localesResult.find(item => item.country.key === locales.country)
        const language = localeInfo?.languages[0]?.key
        setLocal(
          LOCALE_STORE_KEY,
          { country: locales.country, lang: language, timeZone: locales.timeZone },
          { expire: 1000 * 60 * 60 * 24 * 365 }
        )
        window.location.reload()
      }
    }
    // const trInstance = new CreateTRInbound()
    // console.log('mounted - trInstance:', trInstance)
    // this.hasTRCallInExtension = await trInstance.checkExtension()
    // this.callEvent = trInstance.on(CallSdk.EVENT.CALL_STATE_CHANGE, async e => {
    //   console.log('trInstance.on - e:region-callin-loss-report', e)
    //   const callId = e.uniqueId
    //   window.dispatchEvent(
    //     new CustomEvent('avaya', {
    //       detail: { ...e, type: 'call', mode: 'out', status: e.callState, data: { contactId: callId } }
    //     })
    //   )
    // })
    // this.initSharedWorker()
  },
  beforeDestroy() {
    // window.removeEventListener('avaya', this.avayaHandle)
    // window.removeEventListener('avaya-control', this.avayaControlHandle)
    // window.removeEventListener('avaya-connected-state-change', this.connectedStateChange)
    window.removeEventListener('beforeunload', this.listenBeforeunload)
  },
  methods: {
    ...mapActions('app', ['setImStatus']),
    refresh() {
      window.localStorage?.setItem('wb-refresh-mode', 'header-refresh-window')
      refreshWindowAndClearMemory()
    },
    onTrack(params) {
      const { type, seatState, e } = params
      try {
        if (type === 'success') {
          if (seatState === 'busy') this.$libTrack.metric(`电话预约置忙成功`, `tr_callin-busy-success`)
          if (seatState === 'online') this.$libTrack.metric(`客服在线状态切换成功`, `tr_callin-online-success`)
        } else if (type === 'error') {
          if (seatState === 'busy') this.$libTrack.error(`电话预约置忙失败`, e || {}, `tr_callin-busy-error`)
          if (seatState === 'online') this.$libTrack.error(`客服在线状态切换失败`, e || {}, `tr_callin-online-error`)
        }
      } catch (err) {
        console.info(err)
      }
    },
    onError(e) {
      this.$notify.error({
        title: '提示',
        message: e
      })
    },
    // 初始化 SharedWorker
    // initSharedWorker() {
    //   if (this.isIm) return
    //   if (this.hasTRCallInExtension) return
    //   try {
    //     this.sharedWorker = new SharedWorker('/customer-service-workbench/avaya.sharedworker.js?v=1.0.0')
    //     console.log('sharedWorker init', this.sharedWorker)
    //     if (!this.sharedWorker) return
    //     // 开启广播监听
    //     this.sharedWorker.port.onmessage = ({ data }) => {
    //       console.log('sharedWorker onmessage', data, this.currentStatus)
    //       if (data.type === 'state') {
    //         this.stateList = data.stateList
    //       }
    //       // 如果收到离线广播 并且 当前非离线状态 则自动退出坐席
    //       if (data.type === 'reload' && this.currentStatus != 2) {
    //         // Avaya.setCallLeave()
    //         this.currentStatus = 2
    //       }
    //     }
    //     // 初始化状态 2离线
    //     this.sharedWorker?.port?.postMessage({ type: 'state', state: 2 })
    //     window.addEventListener('beforeunload', this.listenBeforeunload)
    //   } catch (error) {
    //     console.warn('initSharedWorker - error:', error)
    //   }
    // },
    listenBeforeunload() {
      // tab刷新和关闭前 告知worker worker识别到null 则销毁当前MessagePort
      this.sharedWorker?.port?.postMessage({ type: 'state', state: null })
    },

    changePassword() {
      window.location.href = `${Config.VUE_APP_SSO}#/password/`
    },
    async logout() {
      await request(`${Config.VUE_APP_SSO}sso/logout`, {
        method: 'post',
        ignoreCode: true,
        withCredentials: true,
        notWithWorkBenchId: true
      })
      this.dialogVisible = false
      const uri = `${window.location.origin}${window.location.pathname}/#/callcenter/index`
      window.location.href = `${Config.VUE_APP_SSO}?url=${encodeURIComponent(uri)}`
    },
    changeStatus(val) {
      if (+this.currentStatus === val) return
      if (this.isIm) {
        this.IMStatusChange(val)
      } else {
        // 振铃 接线 不能切换成别的状态，也不能从别的状态切进来
        if (+this.currentStatus > 3 || +val > 3) return
        // 如果不支持sharedWorker则直接切换状态
        if (!this.sharedWorker) {
          this.statusChange(val)
          return
        }
        console.log('sharedWorker - this.stateList:', this.stateList)
        // 如果通话中则无法更改分机状态
        if (this.stateList.some(state => [4, 5].includes(state)) && this.currentStatus == 2) {
          this.$alert('系统识别到您正在接线中/通话中，无法更改分机状态，请挂机后重新操作')
          return
        }
        // 只要有不是离线状态的tab && 当前tab状态为离线中
        if (!this.stateList.every(state => state == 2) && this.currentStatus == 2) {
          this.$confirm('确认要更改分机状态吗？操作后，其他已登录的页面将离线', '提示', {
            type: 'warning',
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          }).then(async () => {
            this.sharedWorker?.port?.postMessage({ type: 'reload' })
            // 等其他页面先下线
            setTimeout(() => {
              this.statusChange(val)
            }, 1000)
          })
          return
        }
        this.statusChange(val)
      }
      // 前端切换显示 前端的状态显示应该等后端状态或者avaya状态改变后才能切换
    },
    connectedStateChange(val) {
      console.log('connectedStateChange', val)
      this.isReconnect = val?.detail?.state || false
    },
    /** 电话工作台 切换状态  */
    statusChange(val) {
      // 通知后端
      // switch (val) {
      //   case 1: {
      //     Avaya.setCallFree().then(() => {
      //       window.localStorage.setItem('_crm_avaya_status', val) // 记录一下手动设置的状态值
      //     })
      //     break
      //   }
      //   case 2: {
      //     Avaya.setCallLeave().then(() => {
      //       window.localStorage.setItem('_crm_avaya_status', val) // 记录一下手动设置的状态值
      //     })
      //     break
      //   }
      //   case 3: {
      //     Avaya.setCallBusy().then(() => {
      //       window.localStorage.setItem('_crm_avaya_status', val) // 记录一下手动设置的状态值
      //     })
      //     break
      //   }
      //   default:
      //     break
      // }
      // return false
    },
    /** IM 切换状态*/
    async IMStatusChange(val) {
      // 如果是客服切为在线，需要自检内存占用
      // await this.validateMemoryStatus()
      changeStatus({ targetStatus: val })
        .then(v => {
          if (v.data && v.data.data) {
            this.setImStatus(val)
            this.currentStatus = val - 0
            this.$libTrack.trace(`[IM]切换客服状态:${val}`)
            if (val === 1) this.$libTrack.metric(`客服在线状态切换成功`, 'im-online-change-success')
          }
        })
        .catch(e => {
          if (val === 1) {
            this.$libTrack.error(
              `客服在线状态切换失败`,
              { currentStatus: this.currentStatus, error: e },
              'im-online-change-error'
            )
          }
        })
    },
    // async validateMemoryStatus() {
    //   return new Promise((resolve, reject) => {
    //     try {
    //       if (isWarningMemoryStatus()) {
    //         this.$libTrack?.trace?.('检测到您的工作台内存占用较高， 建议您立即重启工作台')
    //         this.$confirm('检测到您的工作台内存占用较高，建议您立即重启工作台！', '提示', {
    //           confirmButtonText: '重启工作台',
    //           cancelButtonText: '忽略提醒',
    //           type: 'warning'
    //         })
    //           .then(() => {
    //             window.open(window.location.href, '_blank')
    //             window.close()
    //             reject()
    //           })
    //           .catch(() => {
    //             this.$libTrack?.trace?.('【检测到您的工作台内存占用较高】忽略提醒')
    //             resolve()
    //           })
    //       }
    //     } catch (e) {
    //       resolve()
    //     }
    //   })
    // },
    // 对状态的监听
    avayaHandle(e) {
      const { type, status } = e.detail
      if (type === 'seat') this.currentStatus = this.statusList.find(item => item.status === status).value
      this.sharedWorker?.port?.postMessage({ type: 'state', state: this.currentStatus })
    },

    // 对话机的操作
    avayaControlHandle(e) {
      // console.info('avaya-control', e.detail)
      // if (!e?.detail?.method) return
      // // 外呼新增随路数据uui，格式必须如下avaya才可识别，携带有任务类型用于后端在avaya层实现防骚扰控制。
      // // 即带bizType的外呼为系统外呼，不带的为直接从avaya外呼
      // const method = e.detail.method
      // const handle = {
      //   dial: ev => {
      //     Avaya.setCallDial(ev.detail.data.number, { userData: { map: { uui: `${ev.detail.data.bizType}` } } })
      //   },
      //   hold: () => {
      //     Avaya.setCallHold()
      //   },
      //   unhold: () => {
      //     Avaya.setCallUnHold()
      //   },
      //   drop: () => {
      //     Avaya.setCallDrop()
      //   }
      // }
      // handle[method](e)
    },
    openUtilsDialog() {
      const vm = this.$createDialog(
        WorkbenchUtilDialog,
        {},
        {
          title: '插件设置',
          width: '720px'
        }
      )
      vm.show()
    }
  }
}
</script>
<style lang="stylus" scoped>
.main-header
  >>>.el-badge
    display: inline-block !important;
  .header-right
    display flex
    width: 100%;
    padding-right:20px;
    .v-flex-fill
      height $nav-header-height
  .float-right
    float right
  .separate
    width 1px
    height 14px
    background #D8D8D8
    margin: 0 12px;
    opacity 0.9;
  .workbench-utils {
    margin-left:10px;
    width:18px;
    height: auto;
    cursor pointer
  }
  /deep/ .nav-header-wrap {
    .header-right{
      .header-right__notify,.header-right__all {
        display:none;
      }
    }
  }
  .left-content{
    display: flex;
    justify-content: flex-end;
    padding-right: 24px;
  }
</style>
